// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActionButtons_actionButtonsContainer__wMwIW {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-top: 10px;
}

.ActionButtons_approveButton__5VwOO {
  min-width: 75px !important;
  height: 32px !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  border-radius: 8px !important;
  border-width: 1.5px !important;
  transition: all 0.2s ease-in-out !important;
  position: relative !important;
  overflow: hidden !important;
}
.ActionButtons_approveButton__5VwOO.ActionButtons_pending__7QRQO {
  background: transparent !important;
  color: #10B981 !important;
  border-color: #10B981 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
}
.ActionButtons_approveButton__5VwOO.ActionButtons_pending__7QRQO::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #10B981 0%, #059669 100%);
  transition: left 0.3s ease-in-out;
  z-index: -1;
}
.ActionButtons_approveButton__5VwOO.ActionButtons_pending__7QRQO:hover {
  color: #ffffff !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3) !important;
}
.ActionButtons_approveButton__5VwOO.ActionButtons_pending__7QRQO:hover::before {
  left: 0;
}
.ActionButtons_approveButton__5VwOO.ActionButtons_pending__7QRQO:active {
  transform: translateY(0) !important;
}
.ActionButtons_approveButton__5VwOO.ActionButtons_approved__B4XPj {
  background: linear-gradient(135deg, #10B981 0%, #059669 100%) !important;
  color: #ffffff !important;
  border-color: #10B981 !important;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.25) !important;
  cursor: default !important;
  pointer-events: none !important;
}
.ActionButtons_approveButton__5VwOO.ActionButtons_approved__B4XPj:hover {
  transform: none !important;
  background: linear-gradient(135deg, #10B981 0%, #059669 100%) !important;
  color: #ffffff !important;
}
.ActionButtons_approveButton__5VwOO.ActionButtons_approved__B4XPj:before {
  display: none;
}
.ActionButtons_approveButton__5VwOO.ActionButtons_approved__B4XPj.ActionButtons_MuiButton-root__nltGq {
  background: linear-gradient(135deg, #10B981 0%, #059669 100%) !important;
  color: #ffffff !important;
}

.ActionButtons_rejectButton__MfgsL {
  min-width: 75px !important;
  height: 32px !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  border-radius: 8px !important;
  border-width: 1.5px !important;
  transition: all 0.2s ease-in-out !important;
  position: relative !important;
  overflow: hidden !important;
}
.ActionButtons_rejectButton__MfgsL.ActionButtons_pending__7QRQO {
  background: transparent !important;
  color: #EF4444 !important;
  border-color: #EF4444 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
}
.ActionButtons_rejectButton__MfgsL.ActionButtons_pending__7QRQO::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #EF4444 0%, #DC2626 100%);
  transition: left 0.3s ease-in-out;
  z-index: -1;
}
.ActionButtons_rejectButton__MfgsL.ActionButtons_pending__7QRQO:hover {
  color: #ffffff !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3) !important;
}
.ActionButtons_rejectButton__MfgsL.ActionButtons_pending__7QRQO:hover::before {
  left: 0;
}
.ActionButtons_rejectButton__MfgsL.ActionButtons_pending__7QRQO:active {
  transform: translateY(0) !important;
}
.ActionButtons_rejectButton__MfgsL.ActionButtons_rejected__09lIG {
  background: linear-gradient(135deg, #EF4444 0%, #DC2626 100%) !important;
  color: #ffffff !important;
  border-color: #EF4444 !important;
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.25) !important;
  cursor: default !important;
  pointer-events: none !important;
}
.ActionButtons_rejectButton__MfgsL.ActionButtons_rejected__09lIG:hover {
  transform: none !important;
  background: linear-gradient(135deg, #EF4444 0%, #DC2626 100%) !important;
  color: #ffffff !important;
}
.ActionButtons_rejectButton__MfgsL.ActionButtons_rejected__09lIG:before {
  display: none;
}
.ActionButtons_rejectButton__MfgsL.ActionButtons_rejected__09lIG.ActionButtons_MuiButton-root__nltGq {
  background: linear-gradient(135deg, #EF4444 0%, #DC2626 100%) !important;
  color: #ffffff !important;
}

.ActionButtons_approveButton__5VwOO.ActionButtons_pending__7QRQO,
.ActionButtons_rejectButton__MfgsL.ActionButtons_pending__7QRQO {
  animation: ActionButtons_subtlePulse__FM7Jy 2s ease-in-out infinite;
}

@keyframes ActionButtons_subtlePulse__FM7Jy {
  0%, 100% {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }
  50% {
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  }
}
.ActionButtons_approveButton__5VwOO.ActionButtons_loading__bNAY7,
.ActionButtons_rejectButton__MfgsL.ActionButtons_loading__bNAY7 {
  pointer-events: none;
  opacity: 0.7;
}
.ActionButtons_approveButton__5VwOO.ActionButtons_loading__bNAY7::after,
.ActionButtons_rejectButton__MfgsL.ActionButtons_loading__bNAY7::after {
  content: "";
  width: 12px;
  height: 12px;
  border: 2px solid transparent;
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: ActionButtons_spin__M-BCX 1s linear infinite;
  margin-left: 4px;
}

.ActionButtons_approveButton__5VwOO:disabled:not(.ActionButtons_approved__B4XPj),
.ActionButtons_rejectButton__MfgsL:disabled:not(.ActionButtons_rejected__09lIG) {
  background: #f3f4f6 !important;
  color: #9ca3af !important;
  border-color: #d1d5db !important;
  cursor: not-allowed !important;
  pointer-events: none !important;
  opacity: 0.6 !important;
}
.ActionButtons_approveButton__5VwOO:disabled:not(.ActionButtons_approved__B4XPj):hover,
.ActionButtons_rejectButton__MfgsL:disabled:not(.ActionButtons_rejected__09lIG):hover {
  transform: none !important;
  background: #f3f4f6 !important;
  color: #9ca3af !important;
}
.ActionButtons_approveButton__5VwOO:disabled:not(.ActionButtons_approved__B4XPj)::before,
.ActionButtons_rejectButton__MfgsL:disabled:not(.ActionButtons_rejected__09lIG)::before {
  display: none !important;
}

@keyframes ActionButtons_spin__M-BCX {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.ActionButtons_viewButton__g\\+Ryc {
  min-width: 40px !important;
  height: 32px !important;
  border-radius: 8px !important;
  border-width: 1.5px !important;
  transition: all 0.2s ease-in-out !important;
  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%) !important;
  border-color: #d1d5db !important;
  color: #6b7280 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
}
.ActionButtons_viewButton__g\\+Ryc:hover {
  background: linear-gradient(135deg, #e5e7eb 0%, #d1d5db 100%) !important;
  border-color: #9ca3af !important;
  color: #374151 !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}
.ActionButtons_viewButton__g\\+Ryc:active {
  transform: translateY(0) !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/time-management/ActionButtons.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AACD;;AAEA;EACC,0BAAA;EACA,uBAAA;EACA,2BAAA;EACA,0BAAA;EACA,6BAAA;EACA,8BAAA;EACA,2CAAA;EACA,6BAAA;EACA,2BAAA;AACD;AACC;EACC,kCAAA;EACA,yBAAA;EACA,gCAAA;EACA,mDAAA;AACF;AACE;EACC,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,6DAAA;EACA,iCAAA;EACA,WAAA;AACH;AAEE;EACC,yBAAA;EACA,sCAAA;EACA,yDAAA;AAAH;AAEG;EACC,OAAA;AAAJ;AAIE;EACC,mCAAA;AAFH;AAMC;EACC,wEAAA;EACA,yBAAA;EACA,gCAAA;EACA,yDAAA;EACA,0BAAA;EACA,+BAAA;AAJF;AAME;EACC,0BAAA;EACA,wEAAA;EACA,yBAAA;AAJH;AAOE;EACC,aAAA;AALH;AASE;EACC,wEAAA;EACA,yBAAA;AAPH;;AAYA;EACC,0BAAA;EACA,uBAAA;EACA,2BAAA;EACA,0BAAA;EACA,6BAAA;EACA,8BAAA;EACA,2CAAA;EACA,6BAAA;EACA,2BAAA;AATD;AAWC;EACC,kCAAA;EACA,yBAAA;EACA,gCAAA;EACA,mDAAA;AATF;AAWE;EACC,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,6DAAA;EACA,iCAAA;EACA,WAAA;AATH;AAYE;EACC,yBAAA;EACA,sCAAA;EACA,wDAAA;AAVH;AAYG;EACC,OAAA;AAVJ;AAcE;EACC,mCAAA;AAZH;AAgBC;EACC,wEAAA;EACA,yBAAA;EACA,gCAAA;EACA,wDAAA;EACA,0BAAA;EACA,+BAAA;AAdF;AAgBE;EACC,0BAAA;EACA,wEAAA;EACA,yBAAA;AAdH;AAiBE;EACC,aAAA;AAfH;AAmBE;EACC,wEAAA;EACA,yBAAA;AAjBH;;AAuBA;;EAEC,mEAAA;AApBD;;AAuBA;EACC;IACC,wCAAA;EApBA;EAsBD;IACC,yCAAA;EApBA;AACF;AAwBA;;EAEC,oBAAA;EACA,YAAA;AAtBD;AAwBC;;EACC,WAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,kCAAA;EACA,kBAAA;EACA,uDAAA;EACA,gBAAA;AArBF;;AA0BA;;EAEC,8BAAA;EACA,yBAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,uBAAA;AAvBD;AAyBC;;EACC,0BAAA;EACA,8BAAA;EACA,yBAAA;AAtBF;AAyBC;;EACC,wBAAA;AAtBF;;AAyBA;EACC;IAAK,uBAAA;EArBJ;EAsBD;IAAO,yBAAA;EAnBN;AACF;AAqBA;EACC,0BAAA;EACA,uBAAA;EACA,6BAAA;EACA,8BAAA;EACA,2CAAA;EACA,wEAAA;EACA,gCAAA;EACA,yBAAA;EACA,mDAAA;AAnBD;AAqBC;EACC,wEAAA;EACA,gCAAA;EACA,yBAAA;EACA,sCAAA;EACA,mDAAA;AAnBF;AAsBC;EACC,mCAAA;EACA,mDAAA;AApBF","sourcesContent":[".actionButtonsContainer {\r\n\tdisplay: flex;\r\n\tgap: 10px;\r\n\talign-items: center;\r\n\tmargin-top: 10px;\r\n}\r\n\r\n.approveButton {\r\n\tmin-width: 75px !important;\r\n\theight: 32px !important;\r\n\tfont-weight: 600 !important;\r\n\tfont-size: 12px !important;\r\n\tborder-radius: 8px !important;\r\n\tborder-width: 1.5px !important;\r\n\ttransition: all 0.2s ease-in-out !important;\r\n\tposition: relative !important;\r\n\toverflow: hidden !important;\r\n\r\n\t&.pending {\r\n\t\tbackground: transparent !important;\r\n\t\tcolor: #10B981 !important;\r\n\t\tborder-color: #10B981 !important;\r\n\t\tbox-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;\r\n\r\n\t\t&::before {\r\n\t\t\tcontent: '';\r\n\t\t\tposition: absolute;\r\n\t\t\ttop: 0;\r\n\t\t\tleft: -100%;\r\n\t\t\twidth: 100%;\r\n\t\t\theight: 100%;\r\n\t\t\tbackground: linear-gradient(135deg, #10B981 0%, #059669 100%);\r\n\t\t\ttransition: left 0.3s ease-in-out;\r\n\t\t\tz-index: -1;\r\n\t\t}\r\n\r\n\t\t&:hover {\r\n\t\t\tcolor: #ffffff !important;\r\n\t\t\ttransform: translateY(-1px) !important;\r\n\t\t\tbox-shadow: 0 4px 12px rgba(16, 185, 129, 0.3) !important;\r\n\r\n\t\t\t&::before {\r\n\t\t\t\tleft: 0;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t&:active {\r\n\t\t\ttransform: translateY(0) !important;\r\n\t\t}\r\n\t}\r\n\r\n\t&.approved {\r\n\t\tbackground: linear-gradient(135deg, #10B981 0%, #059669 100%) !important;\r\n\t\tcolor: #ffffff !important;\r\n\t\tborder-color: #10B981 !important;\r\n\t\tbox-shadow: 0 2px 8px rgba(16, 185, 129, 0.25) !important;\r\n\t\tcursor: default !important;\r\n\t\tpointer-events: none !important;\r\n\r\n\t\t&:hover {\r\n\t\t\ttransform: none !important;\r\n\t\t\tbackground: linear-gradient(135deg, #10B981 0%, #059669 100%) !important;\r\n\t\t\tcolor: #ffffff !important;\r\n\t\t}\r\n\r\n\t\t&:before {\r\n\t\t\tdisplay: none;\r\n\t\t}\r\n\r\n\t\t// Force override any other styles\r\n\t\t&.MuiButton-root {\r\n\t\t\tbackground: linear-gradient(135deg, #10B981 0%, #059669 100%) !important;\r\n\t\t\tcolor: #ffffff !important;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.rejectButton {\r\n\tmin-width: 75px !important;\r\n\theight: 32px !important;\r\n\tfont-weight: 600 !important;\r\n\tfont-size: 12px !important;\r\n\tborder-radius: 8px !important;\r\n\tborder-width: 1.5px !important;\r\n\ttransition: all 0.2s ease-in-out !important;\r\n\tposition: relative !important;\r\n\toverflow: hidden !important;\r\n\r\n\t&.pending {\r\n\t\tbackground: transparent !important;\r\n\t\tcolor: #EF4444 !important;\r\n\t\tborder-color: #EF4444 !important;\r\n\t\tbox-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;\r\n\r\n\t\t&::before {\r\n\t\t\tcontent: '';\r\n\t\t\tposition: absolute;\r\n\t\t\ttop: 0;\r\n\t\t\tleft: -100%;\r\n\t\t\twidth: 100%;\r\n\t\t\theight: 100%;\r\n\t\t\tbackground: linear-gradient(135deg, #EF4444 0%, #DC2626 100%);\r\n\t\t\ttransition: left 0.3s ease-in-out;\r\n\t\t\tz-index: -1;\r\n\t\t}\r\n\r\n\t\t&:hover {\r\n\t\t\tcolor: #ffffff !important;\r\n\t\t\ttransform: translateY(-1px) !important;\r\n\t\t\tbox-shadow: 0 4px 12px rgba(239, 68, 68, 0.3) !important;\r\n\r\n\t\t\t&::before {\r\n\t\t\t\tleft: 0;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t&:active {\r\n\t\t\ttransform: translateY(0) !important;\r\n\t\t}\r\n\t}\r\n\r\n\t&.rejected {\r\n\t\tbackground: linear-gradient(135deg, #EF4444 0%, #DC2626 100%) !important;\r\n\t\tcolor: #ffffff !important;\r\n\t\tborder-color: #EF4444 !important;\r\n\t\tbox-shadow: 0 2px 8px rgba(239, 68, 68, 0.25) !important;\r\n\t\tcursor: default !important;\r\n\t\tpointer-events: none !important;\r\n\r\n\t\t&:hover {\r\n\t\t\ttransform: none !important;\r\n\t\t\tbackground: linear-gradient(135deg, #EF4444 0%, #DC2626 100%) !important;\r\n\t\t\tcolor: #ffffff !important;\r\n\t\t}\r\n\r\n\t\t&:before {\r\n\t\t\tdisplay: none;\r\n\t\t}\r\n\r\n\t\t// Force override any other styles\r\n\t\t&.MuiButton-root {\r\n\t\t\tbackground: linear-gradient(135deg, #EF4444 0%, #DC2626 100%) !important;\r\n\t\t\tcolor: #ffffff !important;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n// Pulse animation for pending buttons\r\n.approveButton.pending,\r\n.rejectButton.pending {\r\n\tanimation: subtlePulse 2s ease-in-out infinite;\r\n}\r\n\r\n@keyframes subtlePulse {\r\n\t0%, 100% {\r\n\t\tbox-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n\t}\r\n\t50% {\r\n\t\tbox-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\r\n\t}\r\n}\r\n\r\n// Loading state\r\n.approveButton.loading,\r\n.rejectButton.loading {\r\n\tpointer-events: none;\r\n\topacity: 0.7;\r\n\r\n\t&::after {\r\n\t\tcontent: '';\r\n\t\twidth: 12px;\r\n\t\theight: 12px;\r\n\t\tborder: 2px solid transparent;\r\n\t\tborder-top: 2px solid currentColor;\r\n\t\tborder-radius: 50%;\r\n\t\tanimation: spin 1s linear infinite;\r\n\t\tmargin-left: 4px;\r\n\t}\r\n}\r\n\r\n// Disabled state when request is processed (approved or rejected)\r\n.approveButton:disabled:not(.approved),\r\n.rejectButton:disabled:not(.rejected) {\r\n\tbackground: #f3f4f6 !important;\r\n\tcolor: #9ca3af !important;\r\n\tborder-color: #d1d5db !important;\r\n\tcursor: not-allowed !important;\r\n\tpointer-events: none !important;\r\n\topacity: 0.6 !important;\r\n\r\n\t&:hover {\r\n\t\ttransform: none !important;\r\n\t\tbackground: #f3f4f6 !important;\r\n\t\tcolor: #9ca3af !important;\r\n\t}\r\n\r\n\t&::before {\r\n\t\tdisplay: none !important;\r\n\t}\r\n}\r\n@keyframes spin {\r\n\t0% { transform: rotate(0deg); }\r\n\t100% { transform: rotate(360deg); }\r\n}\r\n\r\n.viewButton {\r\n\tmin-width: 40px !important;\r\n\theight: 32px !important;\r\n\tborder-radius: 8px !important;\r\n\tborder-width: 1.5px !important;\r\n\ttransition: all 0.2s ease-in-out !important;\r\n\tbackground: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%) !important;\r\n\tborder-color: #d1d5db !important;\r\n\tcolor: #6b7280 !important;\r\n\tbox-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;\r\n\t\r\n\t&:hover {\r\n\t\tbackground: linear-gradient(135deg, #e5e7eb 0%, #d1d5db 100%) !important;\r\n\t\tborder-color: #9ca3af !important;\r\n\t\tcolor: #374151 !important;\r\n\t\ttransform: translateY(-1px) !important;\r\n\t\tbox-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;\r\n\t}\r\n\t\r\n\t&:active {\r\n\t\ttransform: translateY(0) !important;\r\n\t\tbox-shadow: 0 1px 2px rgba(0, 0, 0, 0.1) !important;\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionButtonsContainer": `ActionButtons_actionButtonsContainer__wMwIW`,
	"approveButton": `ActionButtons_approveButton__5VwOO`,
	"pending": `ActionButtons_pending__7QRQO`,
	"approved": `ActionButtons_approved__B4XPj`,
	"MuiButton-root": `ActionButtons_MuiButton-root__nltGq`,
	"rejectButton": `ActionButtons_rejectButton__MfgsL`,
	"rejected": `ActionButtons_rejected__09lIG`,
	"subtlePulse": `ActionButtons_subtlePulse__FM7Jy`,
	"loading": `ActionButtons_loading__bNAY7`,
	"spin": `ActionButtons_spin__M-BCX`,
	"viewButton": `ActionButtons_viewButton__g+Ryc`
};
export default ___CSS_LOADER_EXPORT___;
